/**
 * Diretiva `v-autoplay-muted` para <video> de autoplay silencioso.
 *
 * O iOS/Safari só libera autoplay quando o atributo `muted` já existe no HTML
 * no momento em que o elemento é criado. O Vue aplica `muted` como
 * PROPRIEDADE do DOM (el.muted = true) e não como atributo — em elementos
 * criados no client (listagens que chegam via fetch, fora do SSR) o Safari lê
 * o vídeo como "com som", bloqueia o autoplay e mostra o botão nativo de play.
 *
 * O hook `created` é o único que roda ANTES dos atributos/props do elemento
 * (portanto antes do `src`), que é quando o WebKit decide se o autoplay é
 * permitido. Por isso a correção vive aqui e não no onMounted.
 */
export default defineNuxtPlugin((nuxtApp: any) => {
  nuxtApp.vueApp.directive('autoplay-muted', {
    created(el: HTMLVideoElement) {
      // defaultMuted reflete o atributo `muted` no HTML; muted é o estado atual
      el.defaultMuted = true;
      el.muted = true;
      el.setAttribute('muted', '');
    },
  });
});
